import { Card, CardContent, FormHelperText, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useMergeLinkState } from "./State/MergeLinkState";
import MergeLinkTableCell from "../Table/MergeLinkTableCell";
import SortableTable from "../Table/SortableTable";

const useStyles = makeStyles(() => ({
  root: {
    width: "50%",
  },
  card: {
    width: "98%",
    marginTop: 16,
  },
}));

export const MergeLinkCard = ({ client }) => {
  const classes = useStyles();
  const state = useMergeLinkState(client);

  return (
    <Card className={classes.card}>
      <CardContent>
        <Grid xs={12} sm={12} item style={{ justifyContent: "flex-end" }}>
          <Grid item xs={12} sm={12}>
            <FormHelperText>Merge Integrations</FormHelperText>
          </Grid>
          <Grid item xs={12} sm={12}>
            <SortableTable
              columns={state.getters.columns}
              tableData={state.getters.tableData}
              rowComponent={MergeLinkTableCell}
              loading={state.getters.loading}
              defaultSortIndex={0}
              hideSearch={true}
            />
          </Grid>
        </Grid>
        <Grid
          xs={12}
          sm={12}
          item
          container
          style={{
            justifyContent: "flex-end",
            alignItems: "flex-end",
          }}
        ></Grid>
      </CardContent>
    </Card>
  );
};
